module.exports = __webpack_public_path__ + "static/media/ori.89dad323.svg";